import { render, staticRenderFns } from "./DetalleUsuario.vue?vue&type=template&id=fa1268d4"
import script from "./DetalleUsuario.vue?vue&type=script&lang=js"
export * from "./DetalleUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports